import classNames from 'classnames'
import { forwardRef, Ref } from 'react'
import { PictureCardUpload } from '~/components/business/PictureCardUpload'
import { MyIcon } from '~/components/ui/MyIcon'
import { toCDNImage } from '~/utils'
import Paint from './Paint'

import styles from './PaintWithUpload.module.css'
import { useAtom } from 'jotai'
import { maskImageUrlAtom, selectSizeAtom } from '../ai-form/atom'
import useOptions from '../ai-form/useOptions'

const PaintWithUpload = ({}, ref: Ref<any>) => {
  const [maskImageUrl, setMaskImageUrl] = useAtom(maskImageUrlAtom)
  const [, setSelectSize] = useAtom(selectSizeAtom)

  const { curSizeOptions } = useOptions()

  /** 当上传涂抹图时，为其匹配一个最合适的尺寸 */
  const matchSizeForPaintImage = (ratio: number) => {
    let best: any
    let delta = 10000
    curSizeOptions.map(item => {
      const [w, h] = item.name.split(':')
      const _ratio = Number(w) / Number(h)
      const _delta = Math.abs(_ratio - ratio)
      if (_delta < delta) {
        delta = _delta
        best = item
      }
    })
    setSelectSize(best.name)
  }

  const setUrl = (url: string) => {
    setMaskImageUrl(url)
    const img = new Image()
    img.src = url
    img.onload = () => {
      matchSizeForPaintImage(img.naturalWidth / img.naturalHeight)
    }
  }

  return (
    <div
      className={classNames('relative w-full overflow-hidden', {
        'h-[326px]': !maskImageUrl,
        'h-[370px]': !!maskImageUrl,
      })}
    >
      {!maskImageUrl && (
        <PictureCardUpload
          className={classNames(styles.customUpload, 'relative z-10')}
          needHash={true}
          onChange={setUrl}
          value={maskImageUrl}
          limit={10}
          height={326}
          icon={
            <img
              src={toCDNImage('/images/ai/image.png')}
              alt=""
              className="w-20 h-20 block mx-auto mb-2.5"
            />
          }
          label={
            <>
              <div className="text-sm text-neutral-500 font-semibold mb-2.5">
                拖拽图片到这里，或点击上传
              </div>
              <div className="text-xs text-neutral-400">
                支持图片格式：JPG,PNG，Max：10MB
              </div>
            </>
          }
          showInfo={false}
        ></PictureCardUpload>
      )}

      <div className={classNames('absolute top-0 left-0')}>
        <Paint url={maskImageUrl} ref={ref} />

        <div
          className="w-8 h-8 rounded-lg p-1.5 absolute top-2 right-2 bg-neutral-50/50 cursor-pointer"
          onClick={() => {
            setUrl('')
          }}
        >
          <MyIcon
            icon="trash"
            className="text-[20px] leading-none text-neutral-600"
          ></MyIcon>
        </div>
      </div>
    </div>
  )
}

export default forwardRef(PaintWithUpload)
